export default {"src":"/find-tickets/_next/static/media/ticket_found.10e8689e.svg","height":401,"width":346,"blurWidth":0,"blurHeight":0};